<div>
  <div style="margin-bottom: 20px; font-size: 1.05em">
    {{ 'key_createHcConfiguration' | translate }}
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
    <app-editor-identity
      #idpBaseLayer
      [(ngModel)]="baseLayerResource"
      [creationMode]="true"
      [config]="baseLayerResourceConfig"
      (valueChange)="clear(true)"
      style="width: 100%"
    ></app-editor-identity>
    <app-editor-identity
      #idpUiConfiguration
      [(ngModel)]="uiConfigurationResource"
      [creationMode]="true"
      [config]="uiConfigurationResourceConfig"
      (valueChange)="clear(true)"
      style="width: 100%"
    ></app-editor-identity>
    <div fxFlex="200px">
      <button
        mat-stroked-button
        color="primary"
        [disabled]="!baseLayerResource.value || !uiConfigurationResource.value"
        (click)="onCompare()"
        style="width: 100%; margin-top: -20px"
      >
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
          <div>{{ 'key_compare' | translate }}</div>
          <span class="material-icons-outlined">compare_arrows</span>
        </div>
      </button>
    </div>
  </div>
  <div>
    <mat-card>
      <mat-card-header style="margin-bottom: 10px">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="10px"
          style="width: 100%"
        >
          <mat-card-title style="font-weight: 300; font-size: large">{{
            'key_compareResult' | translate
          }}</mat-card-title>
          <div fxFlex="auto"></div>
          <mat-slide-toggle
            [(ngModel)]="showRawData"
            (change)="onShowRawData()"
            >{{ 'key_showRawData' | translate }}</mat-slide-toggle
          >
        </div>
      </mat-card-header>
      <mat-card-content>
        <app-diff-tree
          [maxHeight]="300"
          [diffResult]="diffResult"
          [isLoading]="isLoading"
          [style.display]="showRawData ? 'none' : 'block'"
          (filteredDiffChange)="onFilteredDiffChange($event)"
          style="width: 100%"
        ></app-diff-tree>
        <div *ngIf="showRawData">
          <mat-form-field
            appearance="fill"
            style="width: 100%"
            class="multi-text"
          >
            <mat-label></mat-label>
            <textarea
              matInput
              rows="10"
              [(ngModel)]="rawDiffResult"
              spellcheck="false"
            ></textarea>
          </mat-form-field>
          <div fxLayout="row" style="width: 100%">
            <button
              mat-stroked-button
              color="primary"
              (click)="copyString(rawDiffResult)"
              [disabled]="!rawDiffResult"
            >
              <div
                fxLayout="row"
                fxLayoutAlign="center center"
                fxLayoutGap="10px"
              >
                <div>{{ 'key_copy' | translate }}</div>
                <span class="material-icons-outlined">content_copy</span>
              </div>
            </button>
            <div fxFlex="auto"></div>
            <button
              mat-stroked-button
              color="primary"
              (click)="rawDiffResult = this.zipString(rawDiffResult)"
              [disabled]="
                !rawDiffResult || rawDiffResult.startsWith('-ZipB64-')
              "
              style="margin-right: 20px"
            >
              <div
                fxLayout="row"
                fxLayoutAlign="center center"
                fxLayoutGap="10px"
              >
                <div>{{ 'l10n_zipSetting' | translate }}</div>
                <span class="material-icons-outlined">compress</span>
              </div>
            </button>
            <button
              mat-stroked-button
              color="primary"
              (click)="rawDiffResult = unzipString(rawDiffResult)"
              [disabled]="
                !rawDiffResult || !rawDiffResult.startsWith('-ZipB64-')
              "
            >
              <div
                fxLayout="row"
                fxLayoutAlign="center center"
                fxLayoutGap="10px"
              >
                <div>{{ 'l10n_unzipSetting' | translate }}</div>
                <span class="material-icons-outlined">expand</span>
              </div>
            </button>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <div style="font-size: 1.05em">
    <div fxLayout="row" style="margin-top: 30px">
      <span
        class="material-icons-outlined warn-color"
        style="margin-left: -5px; margin-right: 5px"
        >report</span
      >
      <div class="warn-color" style="margin-bottom: 5px">
        {{ 'key_importantNotes' | translate }}
      </div>
    </div>
    <div
      [innerHTML]="'key_importantNotesText' | translate"
      style="margin-top: -10px"
    ></div>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
    <mat-form-field appearance="fill" style="width: 100%">
      <mat-label>{{ 'key_newModLayerName' | translate }}</mat-label>
      <input matInput [(ngModel)]="newModLayerName" />
    </mat-form-field>
    <mat-form-field appearance="fill" style="width: 100%">
      <mat-label>{{ 'key_newUiConfigurationName' | translate }}</mat-label>
      <input matInput [(ngModel)]="newUiConfigurationName" />
    </mat-form-field>
    <div fxFlex="200px">
      <button
        mat-stroked-button
        color="primary"
        [disabled]="
          !filteredDiffResult || !newModLayerName || !newUiConfigurationName
        "
        (click)="onConvertToHcConfiguration()"
        style="width: 100%; margin-top: -20px"
      >
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
          <div>{{ 'l10n_convert' | translate }}</div>
          <span class="material-icons-outlined">double_arrow</span>
        </div>
      </button>
    </div>
  </div>
</div>

<!-- <div style="display: none">
  <div fxLayout="row" fxLayoutAlign="center stretch" fxLayoutGap="20px">
    <div fxFlex="50" fxLayout="column" fxLayoutAlign="start start">
      <mat-form-field appearance="fill" style="width: 100%" class="multi-text">
        <mat-label>{{ 'key_baseConfigurationMod' | translate }}</mat-label>
        <textarea
          matInput
          rows="20"
          [(ngModel)]="configBaseMod"
          spellcheck="false"
        ></textarea>
      </mat-form-field>
      <mat-form-field appearance="fill" style="width: 100%" class="multi-text">
        <mat-label>{{ 'key_currentConfiguration' | translate }}</mat-label>
        <textarea
          matInput
          rows="20"
          [(ngModel)]="configCurrent"
          spellcheck="false"
        ></textarea>
      </mat-form-field>
      <div fxLayout="row" style="width: 100%">
        <button
          mat-stroked-button
          color="primary"
          (click)="configCurrent = this.zipString(configCurrent)"
          [disabled]="!configCurrent || configCurrent.startsWith('-ZipB64-')"
        >
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
            <div>{{ 'l10n_zipSetting' | translate }}</div>
            <span class="material-icons-outlined">compress</span>
          </div>
        </button>
        <div fxFlex="auto"></div>
        <button
          mat-stroked-button
          color="primary"
          (click)="configCurrent = unzipString(configCurrent)"
          [disabled]="!configCurrent || !configCurrent.startsWith('-ZipB64-')"
        >
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
            <div>{{ 'l10n_unzipSetting' | translate }}</div>
            <span class="material-icons-outlined">expand</span>
          </div>
        </button>
      </div>
    </div>
    <div fxFlex="50" fxLayout="column" fxLayoutAlign="start start">
      <div style="margin-bottom: 10px">
        {{ 'key_baseModNameInfo' | translate }}
      </div>
      <mat-form-field appearance="fill" style="width: 100%">
        <mat-label>{{ 'key_baseModName' | translate }}</mat-label>
        <input matInput [(ngModel)]="configBaseModName" />
      </mat-form-field>
      <div style="margin-bottom: 10px; margin-top: 30px">
        {{ 'key_modNameInfo' | translate }}
      </div>
      <mat-form-field appearance="fill" style="width: 100%">
        <mat-label>{{ 'key_modName' | translate }}</mat-label>
        <input matInput [(ngModel)]="configModName" />
      </mat-form-field>
      <div style="margin-bottom: 10px; margin-top: 30px">
        {{ 'key_configNameInfo' | translate }}
      </div>
      <mat-form-field appearance="fill" style="width: 100%">
        <mat-label>{{ 'key_configName' | translate }}</mat-label>
        <input matInput [(ngModel)]="configName" />
      </mat-form-field>
      <div fxLayout="row wrap" style="margin-bottom: 10px; margin-top: 30px">
        <span
          class="material-icons-outlined warn-color"
          style="margin-left: -5px; margin-right: 5px"
          >report</span
        >
        <div class="warn-color" style="margin-bottom: 5px">
          {{ 'key_importantNotes' | translate }}
        </div>
        <div [innerHTML]="'key_modImportantNote' | translate"></div>
      </div>
      <button
        style="margin-top: 20px"
        fxFlex="none"
        mat-stroked-button
        color="primary"
        [disabled]="
          !configBaseModName ||
          !configModName ||
          !configName ||
          !configBaseMod ||
          !configCurrent
        "
        (click)="convertToMod()"
      >
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
          <div>{{ 'l10n_convert' | translate }}</div>
          <span class="material-icons-outlined">double_arrow</span>
        </div>
      </button>
    </div>
  </div>
</div> -->

<!-- <div style="display: none">
  <div fxLayout="row" fxLayoutAlign="center stretch" fxLayoutGap="20px">
    <div fxFlex="auto" fxLayout="column" fxLayoutAlign="start start">
      <mat-form-field appearance="fill" style="width: 100%" class="multi-text">
        <mat-label>{{ 'l10n_originalConfig' | translate }}</mat-label>
        <textarea
          matInput
          rows="42"
          [(ngModel)]="configBefore"
          spellcheck="false"
        ></textarea>
      </mat-form-field>
      <div fxLayout="row" style="width: 100%">
        <button
          mat-stroked-button
          color="primary"
          (click)="configBefore = zipString(configBefore)"
          [disabled]="!configBefore || configBefore.startsWith('-ZipB64-')"
        >
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
            <div>{{ 'l10n_zipSetting' | translate }}</div>
            <span class="material-icons-outlined">compress</span>
          </div>
        </button>
        <div fxFlex="auto"></div>
        <button
          mat-stroked-button
          color="primary"
          (click)="configBefore = unzipString(configBefore)"
          [disabled]="!configBefore || !configBefore.startsWith('-ZipB64-')"
        >
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
            <div>{{ 'l10n_unzipSetting' | translate }}</div>
            <span class="material-icons-outlined">expand</span>
          </div>
        </button>
      </div>
    </div>
    <div fxFlex="none" fxLayout="column">
      <div fxFlex="auto"></div>
      <button
        fxFlex="none"
        mat-stroked-button
        color="primary"
        (click)="onConvert()"
        [disabled]="!configBefore"
      >
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
          <div>{{ 'l10n_convert' | translate }}</div>
          <span class="material-icons-outlined">double_arrow</span>
        </div>
      </button>
      <div fxFlex="auto"></div>
    </div>
    <div fxFlex="auto" fxLayout="column" fxLayoutAlign="start start">
      <mat-form-field appearance="fill" style="width: 100%" class="multi-text">
        <mat-label>{{ 'l10n_convertedConfig' | translate }}</mat-label>
        <textarea
          matInput
          rows="42"
          [(ngModel)]="configAfter"
          spellcheck="false"
        ></textarea>
      </mat-form-field>
      <div fxLayout="row">
        <button
          mat-stroked-button
          color="primary"
          (click)="onImport()"
          [disabled]="!configAfter"
          style="margin-right: 20px"
        >
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
            <div>{{ 'key_import' | translate }}</div>
            <span class="material-icons-outlined">upload</span>
          </div>
        </button>
        <button
          mat-stroked-button
          color="primary"
          (click)="onCopy()"
          [disabled]="!configAfter"
        >
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
            <div>{{ 'key_copy' | translate }}</div>
            <span class="material-icons-outlined">content_copy</span>
          </div>
        </button>
      </div>
    </div>
  </div>
</div> -->
